<template>
  <QImage2 :relativePath="relativePath" :size="size" :fallbackIcon="'mdi-package-variant-closed'"></QImage2>
</template>

<script>
import QImage2 from "@/components/Cards/QImage2.vue";

export default {
  name: "MachineModelImage",
  props: {
    size: Number,
    relativePath: String,
  },
  components: {
    QImage2,
  },
  mixins: [],

  data() {
    return {
      path: null,
      imgLoadError: false,
      uploadFile: null,
    };
  },

  mounted() {
    //console.log(this.relativePath);
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>